import { Success, Failure } from 'folktale/validation'
import { splitAndValidateId, joinProduct } from './mapUtils.js'
import BookingProduct from '../models/BookingProduct.js'
import { makeBookingProduct } from './makeBookingProduct.js'

export const mapStringParamToBookingProduct = (products, queryParam) => {
  return splitAndValidateId(queryParam)
    .map(joinProduct(products))
    .fold(
      errors => Failure(errors),
      value => validateProduct(value),
    )
    .map(makeBookingProduct)
}

const validateProduct = value =>
  value.product
    ? Success(value)
    : Failure([`Could not match resourceKey ${value.ResourceKey} from query string to any product`])
